import {Component} from '@angular/core';

@Component({
    selector: 'kkk-loading',
    template: '<span><span class="fa fa-spinner fa-spin"></span><span class="sr-only">Betöltés...</span></span>'
})
export class LoadingComponent {
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/components/loading/loading.component.ts